const API_BASE = process.env.REACT_APP_API_URL || '';

const handleResponse = async (response) => {
  const data = await response.json();
  if (!response.ok) {
    throw new Error(data.error || 'An error occurred');
  }
  return data;
};

export const getStock = async () => {
  const response = await fetch(`${API_BASE}/api/get-stock`);
  return handleResponse(response);
};

export const validateInvite = async (invite) => {
  const response = await fetch(`${API_BASE}/api/validate-invite`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ invite })
  });
  return handleResponse(response);
};

export const checkCoupon = async (coupon) => {
  const response = await fetch(`${API_BASE}/api/check-coupon`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ coupon })
  });
  return handleResponse(response);
};

export const createOrder = async (orderData) => {
  const response = await fetch(`${API_BASE}/api/create-order`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(orderData)
  });
  return handleResponse(response);
};

export const getOrder = async (orderId) => {
  const response = await fetch(`${API_BASE}/api/order/${orderId}`);
  return handleResponse(response);
};

export const getCheckout = async (orderId) => {
  const response = await fetch(`${API_BASE}/api/checkout/${orderId}`);
  return handleResponse(response);
};

export const getPaymentStatus = async (orderId) => {
  const response = await fetch(`${API_BASE}/api/payment-status/${orderId}`);
  return handleResponse(response);
};
